





































































import Campaign, { CampaignFilters } from "@/models/campaign";
import {
  DashboardTabs,
  Meta,
  Pagination,
  TableHeaders,
} from "@/models/general";
import TableActions from "@/components/TableActions.vue";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { formatDate } from "@/helpers/dateHelpers";
import CampaignHelper from "@/helpers/campaign";
import { isEqual, set } from "lodash";
import User from "@/models/user";
import { LayoutModule } from "@/store/layout";
import DashboardCampaignsFilter from "./DashboardCampaignsFilter.vue";
import { DashboardModule } from "@/store/dashboard";

@Component({ components: { TableActions } })
export default class DashboardCampaignsTable extends Vue {
  @Prop() tab!: DashboardTabs;
  @Prop() dataId!: string;
  @Prop() data!: Campaign[];
  @Prop() columns!: string[];
  @Prop() meta!: Meta;
  @Prop() users!: User[];
  headers: TableHeaders[] = [];
  specialHeaders = ["id"];
  pagination: Pagination = new Pagination();
  formatDate = formatDate;

  get totalCount(): number {
    return this.meta ? this.meta.pagination.totalCount : 0;
  }

  get filter(): CampaignFilters {
    return DashboardModule.getFilter as CampaignFilters;
  }

  get isFilterApplied(): boolean {
    return !isEqual(this.tab.filter, DashboardModule.getFilter);
  }

  created(): void {
    this.columns.forEach((c) => {
      this.headers.push({
        text: !this.specialHeaders.includes(c)
          ? this.$t(`campaigns.model.${c}`).toString()
          : "",
        sortable: false,
        value: c,
      });
    });
  }

  viewCampaign(campaign: Campaign): void {
    this.$router.push({
      name: "edit-campaign",
      params: { id: String(campaign.id) },
    });
  }

  campaignStatusColor(status: string): string {
    return CampaignHelper.getColorClass(status);
  }

  getSellerName(id: string): string {
    const u = this.users.find((e) => e.id === id);
    const name = u ? `${u.name} ${u.familyName}` : "";

    return name;
  }

  @Watch("meta")
  setTablePagination(): void {
    this.pagination.page = this.meta.pagination.current;
  }

  @Watch("pagination")
  setHeaders(): void {
    this.$emit("changePage", {
      pagination: this.pagination,
      dataId: this.dataId,
    });
  }

  exportCsv(): void {
    this.$emit("exportCsv", this.tab);
  }

  showFilters(): void {
    LayoutModule.setRightDrawerComponent(DashboardCampaignsFilter);
    LayoutModule.setRightDrawerComponentProps({
      id: this.tab.id,
      tab: this.tab,
    });
    LayoutModule.showRightDrawer();
  }
}
